import React, { FC, useContext, useState } from 'react';
import { Layout, Drawer } from 'antd';
import styled, { ThemeContext } from 'styled-components';
import MediaQuery, { useMediaQuery } from 'react-responsive';

import NavbarLogo from './NavbarLogo';
import Hamburger from './Hamburger';

import DesktopMenu from 'containers/Topbar/DesktopMenu';
import MobileMenu from 'containers/Topbar/MobileMenu';
import LogoMenu from 'containers/Topbar/LogoMenu';

const { Header } = Layout;

const Topbar: FC = () => {
  const [visibleDrawer, setVisibleDrawer] = useState(false);
  const theme = useContext(ThemeContext);
  const isMobile = useMediaQuery({ maxWidth: theme.breakpoints.medium });

  const toggleDrawer = () => {
    setVisibleDrawer(!visibleDrawer);
  };

  return (
    <>
      <AdaptiveHeader $isMobile={isMobile}>
        <Container>
          <MediaQuery minWidth={theme.breakpoints.large}>
            <NavbarLogo />
          </MediaQuery>
          <MediaQuery maxWidth={theme.breakpoints.large}>
            <LogoMenu />
          </MediaQuery>
          <Drawer title="Menu" placement="left" closable={false} onClose={toggleDrawer} visible={visibleDrawer}>
            <MobileMenu />
          </Drawer>
          <MediaQuery minWidth={theme.breakpoints.large}>
            <DesktopMenu />
          </MediaQuery>
          <Hamburger onToggleMenu={toggleDrawer} />
        </Container>
      </AdaptiveHeader>
    </>
  );
};

const AdaptiveHeader = styled(Header)<{ $isMobile: boolean }>`
  position: ${($isMobile) => ($isMobile ? 'fixed' : 'relative')};
  width: 100%;

  & ~ div {
    margin-top: ${($isMobile) => ($isMobile ? '50px' : '0')};
    min-height: 100px;
  }
`;

const Container = styled.div`
  max-width: ${({ theme }) => theme.container.maxWidth};
  margin: 0 auto;
  top: 0;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

export default Topbar;
